module.exports = __webpack_public_path__ + "img/collection-weddingRingsHammered@2x.03b7e4e.webp";